
















































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { CollegesService } from "@/zh-website/src/views/Colleges/service";
import UrbanManagement from "./componts/CollegeDetails/UrbanManagement.vue";
import NorthCentral from "./componts/CollegeDetails/NorthCentral.vue";
import Deepjob from "./componts/CollegeDetails/Deepjob.vue";
import GuizhouElectronics from "./componts/GuizhouElectronics.vue";
import Shenzhiyuan from "./componts/Shenzhiyuan.vue";
import Nangong from "./componts/Nangong.vue";
import Sundar from "./componts/Sundar.vue";
import GanNanKeJi from "@/zh-website/src/views/Colleges/componts/GanNanKeJi.vue";
@Component({
  components: {
    GanNanKeJi,
    Sundar,
    Nangong,
    GuizhouElectronics,
    Shenzhiyuan,
    SideBar,
    Banner,
    UrbanManagement,
    NorthCentral,
    Deepjob
  }
})
export default class Case extends Vue {
  isFixed = false;
  offsetTop = 600;
  // 选中的项
  activeIndex = "";
  content = "";
  // 背景图样式文案
  list = {
    style: {
      backgroundImage: ``,
      height: "493px"
    },
    font1: "",
    font4: "",
    button: ""
  };
  colleges: any[] = [];
  staticMatchList = [
    {
      host: "https://www.zj-huawei.com",
      ids: {
        szy: "1713847500499021826",
        ngy: "1713848290118692865",
        gzdz: "1713848629261725698",
        sdxy: "1713849019032014849",
        cqcg: "1713849587152678913",
        zbxy: "1713850212798042113",
        sjs: "1713850752850423810"
      }
    },
    {
      host: "https://icsl-h5.zj-huawei.com",
      ids: {
        szy: "1713847500499021826",
        ngy: "1713848290118692865",
        gzdz: "1713848629261725698",
        sdxy: "1713849019032014849",
        cqcg: "1713849587152678913",
        zbxy: "1713850212798042113",
        sjs: "1713850752850423810"
      }
    },
    {
      host: "https://icsl-pc.zj-huawei.com",
      ids: {
        szy: "1713847500499021826",
        ngy: "1713848290118692865",
        gzdz: "1713848629261725698",
        sdxy: "1713849019032014849",
        cqcg: "1713849587152678913",
        zbxy: "1713850212798042113",
        sjs: "1713850752850423810"
      }
    },
    {
      host: "https://test-pc.zj-huawei.com",
      ids: { szy: "", ngy: "", gzdz: "", sdxy: "", cqcg: "", zbxy: "", sjs: "" }
    },
    {
      host: "https://dev-pc.zj-huawei.com",
      ids: { szy: "", ngy: "", gzdz: "", sdxy: "", cqcg: "", zbxy: "", sjs: "" }
    }
  ];
  currentStaticIds: any = {
    gnkj:"1780087104780713985",
    szy: "1713847500499021826",
    ngy: "1713848290118692865",
    gzdz: "1713848629261725698",
    sdxy: "1713849019032014849",
    cqcg: "1713849587152678913",
    zbxy: "1713850212798042113",
    sjs: "1713850752850423810"
  };

  @Watch("$route", { immediate: true })
  onRouteChange() {
    // this.currentStaticIds = this.staticMatchList.find(item => {
    //   return item.host == window.location.origin;
    // })?.ids;
    // 专业的id变化  重新请求接口
    this.activeIndex = this.$route.params.type;
    if (this.activeIndex == "1") {
      this.activeIndex = this.colleges[0].carouselId;
    }
    this.list.style.backgroundImage = `url(${
      this.colleges.find(item => {
        return (
          item.id == this.activeIndex || item.carouselId == this.activeIndex
        );
      }).img
    })`;
  }

  getContent() {
    return this.colleges.find(item => {
      return item.id == this.activeIndex || item.carouselId == this.activeIndex;
    }).content;
  }
  // 鼠标hover事件
  changeMask(index) {
    this.activeIndex = index;
    console.log(this.colleges, this.activeIndex);
    this.list.style.backgroundImage = `url("${
      this.colleges.find(item => {
        return (
          item.id == this.activeIndex || item.carouselId == this.activeIndex
        );
      }).img
    }")`;
    // 判断当前tab有没有吸顶
    if (this.isFixed) {
      window.scrollTo(0, 0);
    }
  }
  mounted() {
    //调用接口获取所有院校案例
    // this.currentStaticIds = this.staticMatchList.find(item => {
    //   return item.host == window.location.origin;
    // })?.ids;
    // console.log("案例静态", this.currentStaticIds);
    this.activeIndex = this.$route.params.type;
    this.getCollegeCaseList();
    // handleScroll为页面滚动的监听回调
    window.addEventListener("scroll", this.handleScroll);
  }
  getCollegeCaseList() {
    CollegesService.getCollegeCaseList({})
      .then((res: any) => {
        //this.colleges=res.data
        // console.log("data", res);
        res.data.forEach((item: any, index: number) => {
          this.colleges.push({
            id: item.id,
            carouselId: item.carouselId,
            title: item.title,
            img: item.backResourceUrl,
            content: item.content,
            sort: item.sort
          });
        });
      })
      .then(() => {
        // this.colleges.sort((a, b) => a.sort - b.sort);
        if (this.activeIndex == "1") {
          this.activeIndex = this.colleges[0].carouselId;
        }
        this.list.style.backgroundImage = `url(${
          this.colleges.find(item => {
            return (
              item.id == this.activeIndex || item.carouselId == this.activeIndex
            );
          }).img
        })`;
      });
  }

  destroyed() {
    //
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    const offsetTop = document.getElementById("bar")?.offsetTop;
    // console.log("scrollTop", scrollTop);
    // console.log("offsetTop", offsetTop);

    if (scrollTop > this.offsetTop) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }
}
